import { Inject, Component, ViewEncapsulation, ViewChild, EventEmitter, Output, Input, ChangeDetectorRef, SimpleChanges } from '@angular/core';
import * as Immutable from "immutable"
import { ConfMessageProvider, ConfPageSessionService, ConfiguratorStore } from "../../../providers";
import { ConfDataActionCreator } from "../../../../shared/providers/configurationData";
import { CopyOperationMessage, CopyDestinationMessage } from "../../../../shared/models/responses/messages";
import { TextBoxComponent, GenericDropdownGroup, InputViewModel, ValueChangeEventArgs } from "../../../../../shared/components";
import { NotificationService, NotificationInfo, NotificationType } from "../../../../../shared/components/notification";
import { BaseComponent } from "../../../../shared";
import { AritcoStore } from '../../../../shared/aritco/aritcoStore';
import { AritcoRequest } from '../../../../shared/models';
import { ModelFactory } from '../../../../shared/providers';

@Component({
  selector: 'aritco-copy-conf',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './aritcoCopyConfComponent.html'
})
export class AritcoCopyConfComponent extends BaseComponent {

  public itemsView: Array<InputViewModel> = [];
  public errorMessages: Array<string>;
  
  @Output()
  public onClose = new EventEmitter<any>();

  @Input()
  public configurationId: number;

  public confItems: InputViewModel[] = [];

  constructor(
    @Inject(ConfPageSessionService) public confPageSession: ConfPageSessionService,
    @Inject(ConfMessageProvider) public confMessageProvider: ConfMessageProvider,
    @Inject(ConfDataActionCreator) public confActionCreator: ConfDataActionCreator,
    @Inject(NotificationService) public notificationService: NotificationService,
    @Inject(ConfiguratorStore) public configuratorStore: ConfiguratorStore,
    @Inject(AritcoStore) public aritcoStore: AritcoStore,
    @Inject(ModelFactory) public modelFactory: ModelFactory,
    @Inject(ConfPageSessionService) public storeSession: ConfPageSessionService,
    public cdr: ChangeDetectorRef,
  ) {
    super();
  }

  ngOnInit() {

    // Copy configuration message
    //this.confMessageProvider.onMessagesRequest<CopyOperationMessage>(this.confPageSession.confSessionId, CopyOperationMessage.name, {
    //  listenNewEventsOnly: true, next: (messages: Immutable.List<CopyOperationMessage>) => {

    //    if (messages.size > 0 && messages.get(0).newConfIds.size > 0) {
    //      this.notificationService.notify(<NotificationInfo>{
    //        title: this.strings.CopySuccessful,
    //        message: this.format(this.strings.XConfigurationsCreatedSuccessfully, messages.get(0).newConfIds.size),
    //        type: NotificationType.Success,
    //        selfClose: true
    //      });

    //      // Close the copy form.
    //      this.onCancel.emit();
    //    }
    //  }
    //}).unsubscribeOn(this.unsubscribeSubject);

    this.loadDestinations();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['configurationId']) {
      this.loadDestinations();
    }
  }

  loadDestinations(): void {

    this.blockUI();

    this.confItems = new Array<InputViewModel>();

    let aritcoRequest = this.modelFactory.createRequestOrCommand<AritcoRequest>(AritcoRequest.name);
    aritcoRequest.aritcoCopyTargets = true;
    aritcoRequest.confId = this.configurationId; //this.storeSession.activeConfigurationId;
    aritcoRequest.sessionId = this.storeSession.confSessionId;

    this.aritcoStore.get(aritcoRequest).subscribe(response => {

      this.confItems = [];

      if (!response.items)
        return;

      response.items.forEach(x => {

        let itemModel = new InputViewModel(x.text);
        itemModel.id = x.value.toString();
        itemModel.value = "false";

        this.confItems.push(itemModel);
      });

      this.cdr.detectChanges();
      this.unblockUI();

    }).unsubscribeOn(this.unsubscribeSubject);

  }

  onConfChange(event: ValueChangeEventArgs): void {

    let value: string = "";
    let first: boolean = true;

    this.confItems.forEach((itemModel) => {

      if (itemModel.value == "true") {

        if (first)
          first = false;
        else
          value += ";";

        value += itemModel.id;
      }

    })
  }

  copyValues(): void {
    this.errorMessages = [];
    this.configuratorStore.aritcoCopyConf(this.configurationId, this.confPageSession.confSessionId, this.confItems.filter((x) => x.value == "true").map(a => a.id));
    this.onClose.emit()
  }

}